import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Warehouse from "./Warehouse";
import Inventory from "./Inventory";
import ProductOverview from "./ProductOverview";
import Offer from "./Offer";
import Image from "../library/Image";
import User from "./User";
import ProductVariation from "./ProductVariation";
import StoreDomainProductMapping from "./StoreDomainProductMapping";
import Model from "./Model";
export class Product extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'product_id',
      content: null
    });
    _defineProperty(this, "ProductId", {
      // property name must always have 'Id' at the end
      fieldName: 'product_id',
      content: null
    });
    _defineProperty(this, "WarehouseID", {
      fieldName: 'warehouse_id',
      content: null
    });
    _defineProperty(this, "tab", {
      fieldName: 'tab',
      loading: false,
      content: null
    });
    _defineProperty(this, "ProductName", {
      fieldName: 'product_name',
      fieldTitle: 'Product Name',
      placeholder: null,
      SideShow: true,
      content: null
    });
    _defineProperty(this, "ProductDate", {
      fieldName: 'created_at',
      fieldTitle: null,
      placeholder: null,
      content: null
    });
    _defineProperty(this, "ProductDeleteDate", {
      fieldName: 'deleted_at',
      fieldTitle: null,
      placeholder: null,
      content: null
    });
    _defineProperty(this, "ProductDescription", {
      fieldName: 'product_description',
      fieldTitle: 'Short Description',
      placeholder: 'description',
      content: null
    });
    _defineProperty(this, "ProductSKU", {
      fieldName: 'product_code',
      fieldTitle: 'Product SKU',
      placeholder: 'SKU',
      SideShow: true,
      content: null
    });
    _defineProperty(this, "ProductWareHouse", {
      fieldName: 'product_warehouse',
      model: Warehouse,
      fieldTitle: 'Warehouse',
      placeholder: null,
      content: {}
    });
    _defineProperty(this, "wareHouse", {
      fieldName: 'product_warehouse',
      model: Warehouse,
      fieldTitle: 'Warehouse',
      placeholder: null,
      content: {}
    });
    _defineProperty(this, "ProductAdvertiser", {
      fieldName: 'product_advertiser',
      model: User,
      fieldTitle: 'Advertiser',
      content: {}
    });
    _defineProperty(this, "advertiser", {
      fieldName: 'product_advertiser',
      model: User,
      fieldTitle: 'Advertiser',
      content: null
    });
    _defineProperty(this, "ProductStatus", {
      fieldName: 'product_status',
      fieldTitle: 'Status',
      placeholder: 'status',
      content: 'active',
      options: [{
        value: Product.ACTIVE_STATUS,
        title: 'Active'
      }, {
        value: Product.DRAFT_STATUS,
        title: 'Paused/Draft'
      }]
    });
    _defineProperty(this, "status", {
      fieldName: 'product_status',
      fieldTitle: 'Status',
      placeholder: 'status',
      content: Product.DRAFT_STATUS
    });
    _defineProperty(this, "ProductInventories", {
      fieldName: 'product_inventories',
      model: Inventory,
      fieldTitle: 'Product Inventories',
      placeholder: null,
      content: []
    });
    _defineProperty(this, "inventories", {
      fieldName: 'product_inventories',
      model: Inventory,
      fieldTitle: 'Product Inventories',
      placeholder: null,
      content: []
    });
    _defineProperty(this, "ProductImage", {
      fieldName: 'image',
      fieldTitle: 'Product Image',
      placeholder: 'Product Image',
      model: Image,
      content: null
    });
    _defineProperty(this, "image", {
      fieldName: 'image',
      fieldTitle: 'Product Image',
      placeholder: 'Product Image',
      model: Image,
      content: null
    });
    _defineProperty(this, "ProductOverView", {
      fieldName: 'product_overview',
      model: ProductOverview,
      content: null
    });
    _defineProperty(this, "ProductOffers", {
      fieldName: 'product_offers',
      model: Offer,
      content: null
    });
    _defineProperty(this, "ProductGallery", {
      fieldName: 'product_gallery',
      model: Image,
      content: null
    });
    _defineProperty(this, "VariantType", {
      fieldName: 'variant_type',
      content: Product.SINGLE_VARIANT_TYPE
    });
    _defineProperty(this, "Variations", {
      fieldName: 'product_variations',
      model: ProductVariation,
      content: []
    });
    _defineProperty(this, "wcProductMapping", {
      fieldName: 'wc_product_mapping',
      model: StoreDomainProductMapping,
      content: null
    });
    _defineProperty(this, "privateNote", {
      fieldName: 'private_note',
      content: null
    });
  }
  getProductSku() {
    var _this$ProductSKU;
    return (_this$ProductSKU = this.ProductSKU) === null || _this$ProductSKU === void 0 ? void 0 : _this$ProductSKU.content;
  }
  getSku() {
    var _this$ProductSKU2;
    return (_this$ProductSKU2 = this.ProductSKU) === null || _this$ProductSKU2 === void 0 ? void 0 : _this$ProductSKU2.content;
  }
  getAdvertiser() {
    return this.advertiser.content;
  }
  getAdvertiserName() {
    let advertiser = this.getAdvertiser();
    return advertiser instanceof User ? advertiser.getName() : null;
  }
  getInventories() {
    return this.inventories.content;
  }
  getWarehouse() {
    return this.wareHouse.content;
  }
  getWarehouseName() {
    let warehouse = this.getWarehouse();
    return warehouse instanceof Warehouse ? warehouse.getName() : null;
  }
  getWarehouseImageUrl() {
    let warehouse = this.getWarehouse();
    return warehouse instanceof Warehouse ? warehouse.getImageUrl() : null;
  }
  getProductSelectObject(text = 'text', value = 'value') {
    var _this$ProductName, _this$ProductId;
    return {
      [text !== null && text !== void 0 ? text : 'text']: (_this$ProductName = this.ProductName) === null || _this$ProductName === void 0 ? void 0 : _this$ProductName.content,
      [value !== null && value !== void 0 ? value : 'value']: (_this$ProductId = this.ProductId) === null || _this$ProductId === void 0 ? void 0 : _this$ProductId.content
    };
  }
  getImage() {
    var _this$ProductImage$co, _this$ProductImage, _this$image;
    return (_this$ProductImage$co = (_this$ProductImage = this.ProductImage) === null || _this$ProductImage === void 0 ? void 0 : _this$ProductImage.content) !== null && _this$ProductImage$co !== void 0 ? _this$ProductImage$co : (_this$image = this.image) === null || _this$image === void 0 ? void 0 : _this$image.content;
  }
  getName() {
    return this.ProductName.content;
  }
  getDescription() {
    return this.ProductDescription.content;
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getVariationType() {
    return this.VariantType.content;
  }
  getVariations() {
    return this.Variations.content;
  }
  isVariationMultiple() {
    return this.getVariationType() === Product.MULTIPLE_VARIANT_TYPE;
  }
  hasVariations() {
    return this.isVariationMultiple();
  }
  isVariationSingle() {
    return this.getVariationType() === Product.SINGLE_VARIANT_TYPE;
  }
  getDeleteDate() {
    return this.ProductDeleteDate.content;
  }
  getPrivateNote() {
    return this.privateNote.content;
  }
  getStatus() {
    return this.status.content;
  }
}
_defineProperty(Product, "ACTIVE_STATUS", 'active');
_defineProperty(Product, "DRAFT_STATUS", 'draft');
_defineProperty(Product, "MULTIPLE_VARIANT_TYPE", 'multiple');
_defineProperty(Product, "SINGLE_VARIANT_TYPE", 'single');
export default Product;